import classNames from "classnames";
import styles from "./styles.module.scss";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import { VisualSimilarityIcon } from "../../../../pages/DataPage/CardsView/DataPageFilters/SearchContainer/Icons";
import { Tooltip } from "antd";

interface ActionButtonsProps {
  linkClicked: boolean;
  showSimilarityButton: boolean;
  onLinkClick: () => void;
  onSimilarityClick: (negation?: boolean) => void;
}

const ActionButtons = ({
  onSimilarityClick,
  showSimilarityButton,
}: ActionButtonsProps) => {
  return (
    <div className={styles.actionButtons}>
      {showSimilarityButton && (
        <Tooltip title="Find Similar">
          <div
            onClick={() => onSimilarityClick(false)}
            className={classNames(styles.actionButton, styles.noDetailsClick)}
          >
            <VisualSimilarityIcon />
            <TooltipWrapper id="assetpreview-find-similar-button-tooltip" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default ActionButtons;
